var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',{staticClass:"ml-3 mr-3"},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_c('b-row',{staticClass:"ml-3 mr-3 mb-3"},[_c('b-card',{staticClass:"ml-0 mr-0 p-0 payment-ad-card__card",staticStyle:{"width":"100%","margin":"0 auto"},attrs:{"border-variant":"dark"}},[_vm._t("content")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }